import { authToken, teladocApi } from '@td/api';
const updateBillingInformation = (memberId, ccInfo) => {
  const request = {
    request: {
      creditcard: {
        first_nm: ccInfo.firstName,
        last_nm: ccInfo.lastName,
        number: ccInfo.cardNumber,
        exp_month: ccInfo.expirationMonth,
        exp_year: ccInfo.expirationYear,
        type: ccInfo.cardType,
        state: ccInfo.state,
        country: ccInfo.country,
      },
      address: {
        address1: ccInfo.address1,
        city: ccInfo.city,
        state: ccInfo.state,
        zip: ccInfo.postalCode,
      }
    }
  }
  return teladocApi.post(`/v1/members/${memberId}/billing/update_payment_profile`, request, authToken.get())
};

export default updateBillingInformation;
